import { Component, input, output } from '@angular/core';

import { PrivaLocalizationModule } from '@priva/localization';

import { ProductBoxComponent, TerminalOverlayComponent } from 'app/shared/components';
import { ProductBoxRegistration } from 'app/shared/components/product-box/models';
import { Activity } from 'app/shared/features/activity-selector/models';
import { areProductBoxRegistrationsValid } from 'app/shared/utils';

import { ManualFlowFooterComponent } from '../manual-flow-footer/manual-flow-footer.component';

@Component({
    selector: 'app-manual-input-product-box',
    imports: [
        ManualFlowFooterComponent,
        ProductBoxComponent,
        PrivaLocalizationModule,
        TerminalOverlayComponent,
    ],
    templateUrl: './manual-input-product-box.component.html',
    styleUrl: './manual-input-product-box.component.scss',
})
export class ManualInputProductBoxComponent {
    activity = input<Activity | undefined>();
    title = input('');

    productBoxSelected = output<ProductBoxRegistration[]>();
    closeRequested = output<void>();

    productBoxRegistrations: ProductBoxRegistration[] = [];

    onCloseRequested() {
        this.closeRequested.emit();
    }
    onProductBoxUpdated(productBoxRegistrations: ProductBoxRegistration[]) {
        this.productBoxRegistrations = productBoxRegistrations;
    }

    onSelectionComplete() {
        if (this.productBoxRegistrations.length) {
            const productRegistrations = this.productBoxRegistrations.filter(
                ({ amount, productBoxNumber }) => amount === null && productBoxNumber,
            );
            this.productBoxSelected.emit(productRegistrations);
        }
    }

    areProductRegistrationsValid() {
        return !!(
            this.activity() && areProductBoxRegistrationsValid(this.productBoxRegistrations, this.activity())
        );
    }
}
